<mat-chip-set>
  <mat-chip
    *ngFor="let filter of filterState.controls.selectedFilters.value; let i = index"
    (click)="isEditableChip(filter) && editFilter(filter, $event)"
    (removed)="removeFilter(filter)"
    [matTooltip]="getToolTip(filter)"
  >
    <div
      *ngIf="
        (!limitOneFilter &&
          ((fieldMask.length !== 0 && fieldMask.indexOf(filter.field.name) !== -1) || fieldMask.length === 0)) ||
        (limitOneFilter &&
          i === 0 &&
          ((fieldMask.length !== 0 && fieldMask.indexOf(filter.field.name) !== -1) || fieldMask.length === 0))
      "
      class="flex w-full items-center"
    >
      <div class="truncate grow">{{ filter.field.displayName }} {{ getFormattedValue(filter) }}</div>
      <div class="flex shrink-0">
        <button [attr.data-testid]="'remove-' + filter.selectedMatcher.name" matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
  </mat-chip>



  <div class="self-center ml-[8px]">
    <button
      *ngIf="!autocompletePanel?.isOpen"
      (click)="!allFiltersSelected && addFilterButtonClick(trigger); $event.stopPropagation()"
      [disabled]="allFiltersSelected"
      [class.disabled]="allFiltersSelected"
      [attr.aria-disabled]="allFiltersSelected"
      [attr.data-all-filters-selected]="allFiltersSelected"
      class="add-filter-button flex flex-row space-x-[8px]"
      type="button"
    >
      <lib-cdw-icon class="add-icon" icon="add"></lib-cdw-icon>
      <span>Add a filter</span>
    </button>
    <div>
      <mat-form-field
        [ngStyle]="{ display: !autocompletePanel?.isOpen ? 'none' : 'flex' }"
        class="filter-chip-list"
        appearance="fill"
        [formGroup]="filterState"
      >
        <mat-chip-grid #chipList aria-label="Filter selection" data-testid="chip-grid">
          <input
            class="filter-input"
            data-testid="filter-input"
            #filterInput
            #trigger="matAutocompleteTrigger"
            formControlName="filterBarInput"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            (blur)="clearInput()"
            (keyup)="updateSuggestedMatchers()"
          />
        </mat-chip-grid>
        <mat-autocomplete
          #autoCompletePanel
          #auto="matAutocomplete"
          (optionSelected)="startNewFilter($event)"
          hideSingleSelectionIndicator
        >
          <div *ngIf="filterInput.value.length > 0">
            <ng-container *ngFor="let defaultMatcher of suggestedMatchersList">
              <mat-option
                *ngIf="defaultMatcher.field.hidden !== true && defaultMatcher.field.masked !== true"
                [value]="defaultMatcher"
              >
                {{ defaultMatcher.field.displayName }} {{ defaultMatcher.suggestedMatcher.displayName | lowercase }} "{{
                  filterInput.value
                }}"
              </mat-option>
            </ng-container>
            <mat-divider></mat-divider>
          </div>
          <ng-container *ngFor="let filter of filteredFieldList | async">
            <mat-option
              [value]="filter"
              [attr.data-testid]="filter.name"
              *ngIf="
                filter.hidden !== true &&
                ((fieldMask.length !== 0 && fieldMask.indexOf(filter.name) !== -1) || fieldMask.length === 0)
              "
            >
              {{ filter.displayName }}
            </mat-option>
          </ng-container>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
    <!-- Clear Filters Link -->
  <button
    *ngIf="filterState.controls.selectedFilters.value.length > 0"
    (click)="clearFilters()"
    class="text-tertiary-blue-cta font-bold text-sm cursor-pointer hover:underline ml-3"
    type="button"
  >
    Clear filters
  </button>
</mat-chip-set>
